import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Star, BadgeCheckIcon } from 'lucide-react';
export function TestimonialsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const testimonials = [{
    name: 'María G.',
    image: 'https://i.pravatar.cc/150?img=5',
    quote: 'Antes no podía correr ni 5 minutos sin sentir que me moría. Hoy corrí mis primeros 5K y no lo puedo creer. Este plan cambió todo.',
    rating: 5
  }, {
    name: 'Carlos F.',
    image: 'https://i.pravatar.cc/150?img=12',
    quote: 'Siempre abandonaba en la semana 2. Con este sistema llegué hasta el final porque cada día sabía exactamente qué hacer. Ya no dependo de la motivación.',
    rating: 5
  }, {
    name: 'Laura M.',
    image: 'https://i.pravatar.cc/150?img=9',
    quote: 'Pensaba que correr no era para mí. Ahora corro 3 veces por semana y me siento increíble. El método progresivo fue clave.',
    rating: 5
  }, {
    name: 'Diego R.',
    image: 'https://i.pravatar.cc/150?img=14',
    quote: 'De no poder correr 2 minutos a completar 5K en 8 semanas. Sin lesiones, sin frustración. Simplemente seguí el plan y funcionó.',
    rating: 5
  }, {
    name: 'Nicolás P.',
    image: 'https://i.pravatar.cc/150?img=33',
    quote: 'Arrancaba todos los lunes y abandonaba el jueves. Me frustraba muchísimo porque sentía que nunca iba a poder. Con este plan dejé de pensar y simplemente seguí los pasos. Hoy ya corro sin parar y, por primera vez, terminé algo que empecé.',
    rating: 5
  }, {
    name: 'Sofía H.',
    image: 'https://i.pravatar.cc/150?img=45',
    quote: 'Siempre encontraba excusas: que no tenía tiempo, que estaba cansado, que mañana empezaba. Este sistema me sacó eso de encima. Es tan claro que no tenés que pensar nada. Pasé de no correr nada a completar mis primeros 5K sin darme cuenta.',
    rating: 5
  }, {
    name: 'Martín L.',
    image: 'https://i.pravatar.cc/150?img=52',
    quote: 'Me daba vergüenza salir a correr porque duraba menos de 3 minutos. Sentía que todos podían menos yo. Este método fue distinto porque arranca desde cero de verdad. Hoy corro seguido y ya no me siento ese que abandona todo.',
    rating: 5
  }, {
    name: 'Valentina R.',
    image: 'https://i.pravatar.cc/150?img=44',
    quote: 'Probé mil veces empezar a correr y siempre lo dejaba porque no veía progreso. Acá es diferente: cada semana avanzás un poco y eso te motiva sin darte cuenta. Lo mejor es que no dependés de ganas, el plan te lleva.',
    rating: 5
  }];
  return <section ref={ref} className="py-20 px-4 bg-navy-light" data-id="element-154">
      <div className="max-w-6xl mx-auto" data-id="element-155">
        <motion.h2 className="text-4xl md:text-5xl font-black mb-4 text-center" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-156">
          Personas como vos <span className="text-accent" data-id="element-157">ya lo lograron</span>
        </motion.h2>

        <motion.p className="text-xl text-gray-300 text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-158">
          Más de 500 personas transformaron su vida con este método
        </motion.p>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-159">
          {testimonials.map((testimonial, i) => <motion.div key={i} className="bg-navy p-8 rounded-2xl border border-accent/20" initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.3 + i * 0.1
        }} whileHover={{
          scale: 1.02
        }} data-id="element-160">
              {/* Stars */}
              <div className="flex gap-1 mb-4" data-id="element-161">
                {[...Array(testimonial.rating)].map((_, j) => <Star key={j} className="text-yellow-400 fill-yellow-400" size={20} data-id="element-162" />)}
              </div>

              {/* Quote */}
              <p className="text-lg text-gray-300 mb-6 leading-relaxed italic" data-id="element-163">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4" data-id="element-164">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full border-2 border-accent" data-id="element-165" />
                <div className="flex items-center gap-2" data-id="element-166">
                  <p className="font-bold text-white" data-id="element-167">{testimonial.name}</p>
                  <BadgeCheckIcon className="text-blue-400 fill-blue-400" size={18} data-id="element-168" />
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}